import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, Output, ViewChild, inject } from '@angular/core';
import {Mode} from '../../../models/mode';
import {Observable} from 'rxjs';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {VwuiModalService} from '@bvgo-ict/vwui-angular';
import {ProjectReferenceDownloadModalComponent} from '../../project-reference-download-modal/project-reference-download-modal.component';
import {ProjectReferenceDetailResponse} from '../../../models/project-reference-detail.response';
import {ProjectReferenceViewModeService} from '../../../services/project-reference-view-mode.service';
import {ActivatedRoute} from '@angular/router';
import {map} from 'rxjs/operators';
import {Authority} from '../../../models/authority';

@Component({
    selector: 'app-prd-header',
    templateUrl: './prd-header.component.html',
    animations: [
        trigger('visibility', [
            state('hidden', style({ opacity: 0, pointerEvents: 'none' })),
            state('visible', style({ opacity: 1, pointerEvents: 'auto' })),
            transition('hidden => visible', animate('2s ease-in-out')),
            transition('visible => hidden', animate('0s')),
        ])
    ],
    standalone: false
})
export class PrdHeaderComponent implements AfterViewInit, OnDestroy {
    private activatedRoute = inject(ActivatedRoute);
    private vwuiModalService = inject(VwuiModalService);
    projectReferenceViewModeService = inject(ProjectReferenceViewModeService);

    @Input() title = 'PRS Projectnaam';
    @Input() showPublish: boolean = true;
    @Input() showConcept: boolean = false;
    @Input() mode$: Observable<Mode>|undefined;
    @Input() state = '';
    @Input() projectReference: ProjectReferenceDetailResponse | undefined;
    @Input() kvwNumber: string | null = null;
    @Output() modeChanged = new EventEmitter<Mode>();
    @Output() saveClicked = new EventEmitter<void>();
    @Output() publishClicked = new EventEmitter<void>();
    @Output() conceptClicked = new EventEmitter<void>();
    @Output() backBtnClicked = new EventEmitter<void>();
    @ViewChild('nav') nav: ElementRef<HTMLElement> | undefined = undefined;

    ModeEdit = Mode.Edit;
    ModeRead = Mode.Read;
    isIntersecting = true;

    collectionIds$ = this.activatedRoute.queryParamMap.pipe(
        map(paramMap => paramMap.has('collectionIds')
            ? paramMap.get('collectionIds')?.split(',')?.map(it => +it)
            : null
        )
    )

    authorities = Authority

    private observer: IntersectionObserver|undefined = undefined;

    ngAfterViewInit(): void {
        if (this.nav) {
            this.observer = new IntersectionObserver(
                ([event]) => this.isIntersecting = event.isIntersecting,
                { threshold: [1] }
            );
            this.observer.observe(this.nav.nativeElement);
        }
    }

    ngOnDestroy(): void {
        if (this.observer && this.nav) {
            this.observer.unobserve(this.nav.nativeElement);
        }
    }

    setEditMode() {
        this.projectReferenceViewModeService.setEditMode();
        this.modeChanged.next(Mode.Edit);
    }

    setReadMode() {
        this.projectReferenceViewModeService.setReadMode();
        this.modeChanged.next(Mode.Read);
    }

    showDownloadModal() {
        this.vwuiModalService.open(ProjectReferenceDownloadModalComponent, {
            modalClass: 'vwui-modal--small',
            data: {
                projectReference: this.projectReference,
                title: this.title
            }
        })
    }
}
